import React, { useEffect, useState } from "react";
import UploadImage from "../UploadImage";
import UploadFile from "../UploadFile";
import PrimaryButton from "../Button/PrimaryButton";
import { isNullOrUndefined } from "../../utils/utils";
import { StaticAPI } from "../../utils/StaticAPI";
import { toast } from "react-toastify";
import * as API from "../../utils/service";
import SuccessToster from "../TosterComponents/SuccessToster";
import ErrorToster from "../TosterComponents/ErrorToster";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

export default function AccountClosureFileDialoge({ formikState, isCmr }) {
  const [imageLogData, setImageLogData] = useState(null);
  const [fileLogData, setFileLogData] = useState(null);

  const imageUploadAPI = async () => {
    try {
      const imageResponse = await API.daoPostMethodForUpload(
        StaticAPI.uploadImage,
        {
          image: imageLogData?.fileDetail,
        }
      );
      toast(<SuccessToster successMessage={"Signature Image Uploaded"} />, {
        toastId: "signature-image-upload-success",
      });
    } catch (error) {
      console.error("Error uploading image:", error);
      toast(<ErrorToster errorMessage={error?.response?.data?.message} />, {
        toastId: "error-signature-image-upload",
      });
      return; // Exit early if this step fails
    }
  };

  const fileUploadAPI = async () => {
    try {
      const fileResponse = await API.daoPostMethodForUpload(
        StaticAPI.uploadPdf,
        {
          pdf: fileLogData?.fileDetail,
        }
      );
      toast(<SuccessToster successMessage={"CMR Uploaded"} />, {
        toastId: "cmr-pdf-upload-success",
      });
    } catch (error) {
      console.error("Error uploading CMR copy:", error);
      toast(<ErrorToster errorMessage={error?.response?.data?.message} />, {
        toastId: "error-cmr-pdf-upload",
      });
      return; // Exit early if this step fails
    }
  };

  useEffect(() => {
    if (!isNullOrUndefined(imageLogData)) {
      imageUploadAPI();
    }
  }, [imageLogData]);
  useEffect(() => {
    if (!isNullOrUndefined(fileLogData)) {
      fileUploadAPI();
    }
  }, [fileLogData]);

  return (
    <form
      onSubmit={formikState?.handleSubmit}
      className="flex flex-col gap-14 min-w-[446px] px-4 md:px-[54px] py-3 md:py-11 border md:border-pkt-rgba-220-218-225-0.50 rounded-lg drop-shadow-lg bg-white z-10"
    >
      <div className="text-xl text-center font-semibold text-pkt-heading">
        <span>Please upload all useful Documents here</span>
      </div>
      <div className="flex flex-col  gap-5">
        <div className="flex flex-col gap-5">
          <UploadImage
            formikState={formikState}
            imageLogData={imageLogData}
            setImageLogData={setImageLogData}
          />
        </div>
        {isCmr && (
          <div className="flex flex-col gap-5">
            <span className="text-sm text-center">
              CMR has to be digitally signed by official of the target DP (CMR
              applicable in case of account having security balances
            </span>
            <UploadFile
              formikState={formikState}
              fileLogData={fileLogData}
              setFileLogData={setFileLogData}
            />
          </div>
        )}
      </div>
      <PrimaryButton
        size={"large"}
        name={"Esign"}
        height={"60px"}
        borderRadius={"10px"}
        type="submit"
        isDisabled={
          isNullOrUndefined(imageLogData)
            ? true
            : isNullOrUndefined(fileLogData) && isCmr
            ? true
            : false
        }
      />
    </form>
  );
}
